import React from 'react'
import { Link } from 'react-router-dom'
import { FiArrowRight, FiPhone } from 'react-icons/fi'
import { resolveMediaUrl } from '../services/api'

export default function StaffCard({ member }) {
  const imageUrl = resolveMediaUrl(member.profileImageUrl)
  const initials = member.name
    .split(' ')
    .map((part) => part[0])
    .join('')
    .slice(0, 2)
    .toUpperCase()

  return (
    <article className="surface-card overflow-hidden">
      <div className="relative aspect-[4/3] overflow-hidden">
        {member.profileImageUrl ? (
          <img src={imageUrl} alt={member.name} className="h-full w-full object-cover" />
        ) : (
          <div className="flex h-full w-full items-center justify-center bg-gradient-to-br from-rose-100 to-stone-100 font-heading text-6xl text-rose-700">
            {initials}
          </div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/15 to-transparent" />
        <div className="absolute inset-x-0 bottom-0 p-6 text-white">
          <p className="text-xs uppercase tracking-[0.18em] text-white/70">Studio role</p>
          <h3 className="mt-2 font-heading text-4xl leading-none">{member.name}</h3>
        </div>
      </div>
      <div className="p-7">
        <p className="text-sm font-semibold uppercase tracking-[0.18em] text-rose-700">{member.specialty}</p>
        <p className="mt-4 text-sm leading-7 text-stone-600">{member.bio}</p>
        <div className="mt-6 flex flex-wrap items-center justify-between gap-3">
          <div className="inline-flex items-center gap-2 rounded-full bg-stone-100 px-4 py-2 text-xs font-semibold uppercase tracking-[0.16em] text-stone-600">
            <FiPhone />
            {member.phone}
          </div>
          <Link to="/booking" className="inline-flex items-center gap-2 text-sm font-semibold text-stone-900">
            Book with the studio
            <FiArrowRight />
          </Link>
        </div>
      </div>
    </article>
  )
}
